(function () {
    'use strict';

    angular.module("imApp").factory("bulkMailService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3103,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3104,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();